import type { ActivePromoCampaign, PromoCampaignContext, RegisteredPromoCampaign } from './types';

export function resolveActivePromoCampaignFromList(
  campaigns: RegisteredPromoCampaign[],
  ctx: PromoCampaignContext
): ActivePromoCampaign | null {
  // A forced campaign must win over an earlier-registered campaign that only matches the fetched promotion.
  if (ctx.forcedPromotionId) {
    const forced = findFirstResolvedCampaign(campaigns, { ...ctx, promotionId: undefined });
    if (forced) {
      return forced;
    }
  }

  return findFirstResolvedCampaign(campaigns, ctx);
}

function findFirstResolvedCampaign(
  campaigns: RegisteredPromoCampaign[],
  ctx: PromoCampaignContext
): ActivePromoCampaign | null {
  for (const campaign of campaigns) {
    if (!campaign.matches(ctx)) {
      continue;
    }

    const resolved = campaign.resolve(ctx);
    if (resolved == null) {
      continue;
    }

    return { campaign, resolved };
  }

  return null;
}
